import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { Dropdown } from 'tdesign-react';
import styled from 'styled-components';

function PartitionSelect({ partition, currentPart, onChange, ...others }) {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    const partList = partition.topicPartitionMetricsList || [];
    if (!isEmpty(partList)) {
      setOptions(
        partList.map((item) => ({
          content: `Partition ${item.partition}`,
          value: item.partition,
        })),
      );
      onChange(partList[0].partition);
    }
  }, [partition, onChange]);

  return (
    <Dropdown options={options} onClick={(data) => onChange(data.value)}>
      <PartitionButton {...others}>
        Partition = {currentPart} <Icon src={require('./images/change.png')} />
      </PartitionButton>
    </Dropdown>
  );
}

export default connect((state) => ({
  partition: state.topic.partition,
}))(PartitionSelect);

const PartitionButton = styled.div`
  color: var(--td-font-gray-1);
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 20px;
  padding-left: 3px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

const Icon = styled.img`
  width: 16px;
  height: 16px;
  margin-left: 8px;
`;
